<script setup lang="ts">
import SiteFooter from "@/components/SiteFooter.vue";
import SiteHeader from "@/components/SiteHeader.vue";
</script>

<template>
  <div class="site-shell">
    <a href="#main-content" class="skip-link">Skip to content</a>
    <SiteHeader />
    <main id="main-content" tabindex="-1"><RouterView /></main>
    <SiteFooter />
  </div>
</template>
